import { render, staticRenderFns } from "./listMessage.vue?vue&type=template&id=747b2821&scoped=true"
import script from "./listMessage.vue?vue&type=script&lang=js"
export * from "./listMessage.vue?vue&type=script&lang=js"
import style0 from "./listMessage.vue?vue&type=style&index=0&id=747b2821&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747b2821",
  null
  
)

export default component.exports